module.exports = __webpack_public_path__ + "static/img/ent-detail-2.7f97a65.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/productspic/entpic/ent-detail-2.jpg
// module id = gDk5
// module chunks = 52